const CONFIG = {
    SECRET_KEY: import.meta.env.VITE_SECRET_KEY,
    SERVER_BASE_URL: import.meta.env.VITE_BASE_URL_API,
};

export default CONFIG;
